import {ReactNode} from 'react';
import type {ToastTransition} from 'react-toastify';

export interface IAfterActionProps {
	notifyContent?: INotifyContent;
	callback?: () => void;
}

interface INotifyContent {
	content: string | ReactNode;
	type: 'success' | 'error';
	options?: {
		position?: 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left'
		transition?: ToastTransition
	}
}

export enum EActionType {
	WISHLIST_ADDED = 'wishlistAdded',
	WISHLIST_REMOVED = 'wishlistRemoved',
	MOVED_TO_WISHLIST = 'movedTowishlistSuccess',
	WISHLIST_ERROR = 'wishlistError',
	CART_ADDED = 'cartAdded',
	CART_ERROR = 'cartError',
	GENERIC_ERROR = 'genericError',
}